import React, { useCallback, useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  InputAdornment, // Import Grid from MUI
} from "@mui/material";
import { Edit, Visibility, VisibilityOff } from "@mui/icons-material";
import { get, postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import {
  apiErrorToast,
  okSuccessToast,
  okSuccessToastsm,
} from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import Loader from "../../component/loading-screen/Loader";
import ModalFooter from "../../modals/ModalFooter";
import { PATTERNS } from "../../utils/ValidationUtil";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "../../component/loading-screen/Spinner";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 5,
  height: "max-content",
  overflowY: "auto",
  borderRadius: "10px",
};

const EditCustomer = ({ user, refresh }) => {
  const [open, setOpen] = useState(false);
  const [updaLoading, setUpdateLoading] = useState(false);
  const [request, setRequest] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [updatedData, setUpdatedData] = useState({});
  const [roles, setRoles] = useState([]);
  const [subRole, setSubRoles] = useState([]);
  const [isPassV, setIsPassV] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [rolesFetched, setRolesFetched] = useState(false);
  const [subRolesFetched, setSubRolesFetched] = useState(false);
  const [isPassValid, setIsPassValid] = useState(true);
  const [formData, setFormData] = useState({
    id: user.id || "",
    name: user.name || "",
    gender: user.gender || "",
    username: user.username || "",
    mobile: user.mobile || "",
    email: user.email || "",
    // password: "",
    role: user.role || "",
    status: user.status || "",
    sub_role: user.sub_role || "",
    establishment: user.establishment || "", // For the new establishment field
    in_time:
    user.role !== "Merchant" && user.role !== "Admin"
      ? user.in_time || ""
      : "",
  out_time:
    user.role !== "Merchant" && user.role !== "Admin"
      ? user.out_time || ""
      : "",
  });

  const handleOpen = () => {
    setFormData({
      id: user.id || "",
      name: user.name || "",
      gender: user.gender || "",
      username: user.username || "",
      mobile: user.mobile || "",
      email: user.email || "",
      // password: "",
      role: user.role || "",
      status: user.status || "",
      sub_role: user.sub_role || "",
      establishment: user.profile?.establishment || "" ,
      in_time:
    user.role !== "Merchant" && user.role !== "Admin"
      ? user.in_time || ""
      : "",
  out_time:
    user.role !== "Merchant" && user.role !== "Admin"
      ? user.out_time || ""
      : "",
    });
    setOpen(true);
    getRoles("subrole")
    getRoles("role")
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const updateUser = useCallback(async () => {
    setUpdateLoading(true);

    postJsonData(
      `${ApiEndpoints.UPDATE_USERS_BIGG}/${user.id}`,
      formData,
      setUpdateLoading,
      (res) => {
        okSuccessToast(res.data.message);
        setUpdateLoading(false);
        setOpen(false);
        refresh();
      },
      (error) => {
        apiErrorToast(error);
        setOpen(false);
      }
    );
  }, [user.id, formData, refresh]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateUser();
  };
  const getRoles = useCallback(
    async (queryType) => {
      let query = queryType === "role" ? "type=Role" : "type=SubRole";
      let url = `${ApiEndpoints.GET_UTILS}?${query}`;

      if (
        (queryType === "role" && rolesFetched) ||
        (queryType === "subRole" && subRolesFetched)
      ) {
        return;
      }

      setRequest(true);
      get(
        url,
        "",
        setRequest,
        (res) => {
          const rolesArray = res.data.data || [];
          if (queryType === "role") {
            setRoles(rolesArray.map((item) => item.name));
            setRolesFetched(true);
          } else {
            setSubRoles(rolesArray.map((item) => item.name));
            setSubRolesFetched(true);
          }
          setRequest(false);
        },
        (error) => {
          apiErrorToast(error);
          setRequest(false);
        }
      );
    },
    [rolesFetched, subRolesFetched]
  );
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setFormData({ ...formData, password: newPassword });
    setIsPassValid(PATTERNS.PASSWORD.test(newPassword));
  };

  return (
    <Box>
      <Tooltip title="Edit User">
        <IconButton color="#fff" onClick={handleOpen}>
          <EditIcon />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style} className="sm_modal">
          <Spinner loading={updaLoading} />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
              p: 1,
              borderBottom: "2px solid #ccc",
            }}
          >
            <Typography
              sx={{ fontSize: "22px", fontWeight: "bold", color: "#000" }}
            >
              Edit User
            </Typography>
               <Spinner loading={request} />
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            component="form"
            onSubmit={handleSubmit}
            id="edit-customer"
            noValidate
            autoComplete="off"
          >
            {/* Wrap fields in Grid for better control */}
            <Grid container spacing={1.2}>
              <Grid item xs={6}>
                <Typography variant="body1" gutterBottom>
                  Name
                </Typography>
                <TextField
                  fullWidth
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="textfield"
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" gutterBottom>
                  UserName
                </Typography>
                <TextField
                  fullWidth
                  className="textfield"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" gutterBottom>
                  Number
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  className="textfield"
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" gutterBottom>
                  Email
                </Typography>
                <TextField
                  fullWidth
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="textfield"
                  required
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" gutterBottom>
                  Gender
                </Typography>
                <TextField
                  fullWidth
                  className="textfield"
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" gutterBottom>
                  Role
                </Typography>
                <TextField
                  select
                  name="role"
                  value={formData.role}
                  onClick={() => getRoles("role")} // Call API when clicked
                  onChange={handleChange}
                  fullWidth
                  required
                  className="textfield"
                >
                  {roles.map((role, index) => (
                    <MenuItem key={index} value={role}>
                      {role}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {(user.role === "Developer" ||
                user.role === "DEVELOPER" ||
                user.role === "developer" ||
                user.role === "Trainee") && (
                <Grid item xs={6}>
                  <Typography variant="body1" gutterBottom>
                    SubRole
                  </Typography>
                  <TextField
                    select
                    name="sub_role"
                    value={formData.sub_role}
                    onChange={handleChange}
                    onClick={() => getRoles("subrole")} 
                   
                    fullWidth
                    required
                    className="textfield"
                  >
                    {subRole.map((role, index) => (
                      <MenuItem key={index} value={role}>
                        {role}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}
                  {(user.role === "Trainee" ||
                              user.role === "Backend" ||
                              user.role === "Developer") && (
                              <>
                                <Grid item xs={12} sm={6}>
                                  <Typography variant="body1" gutterBottom>
                                    In Time
                                  </Typography>
                                  <TextField
                                    name="in_time"
                                    value={formData.in_time}
                                    onChange={handleChange}
                                    required
                                    className="textfield"
                                    fullWidth
                                  />
                                </Grid>
              
                                <Grid item xs={12} sm={6}>
                                  <Typography variant="body1" gutterBottom>
                                    Out Time
                                  </Typography>
                                  <TextField
                                    name="out_time"
                                    value={formData.out_time}
                                    onChange={handleChange}
                                    required
                                    className="textfield"
                                    fullWidth
                                  />
                                </Grid>
                              </>
                            )}
   {formData.role === "Merchant" && (
                <Grid item xs={12}>
                  <Typography variant="body1" gutterBottom>Establishment</Typography>
                  <TextField
                    fullWidth
                    name="establishment"
                    value={formData.establishment}
                    onChange={handleChange}
                    className="textfield"
                  />
                </Grid>
              )}
              <Grid item xs={6}>
                <Typography variant="body1" gutterBottom>
                  Status
                </Typography>
                <TextField
                  select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="textfield"
                  fullWidth
                  required
                >
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">InActive</MenuItem>
                </TextField>
              </Grid>
              {/* <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  Password
                </Typography>
                <TextField
                  fullWidth
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handlePasswordChange}
                  error={!isPassValid}
                  className="textfield"
                  helperText={
                    !isPassValid
                      ? "Password must be alphanumeric, include one special character, and be at least 8 characters long."
                      : ""
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid> */}
            </Grid>

            <Box sx={{ mr: "5px", }}>
              <ModalFooter
                form="edit-customer"
                request={updaLoading}
                btn="Update"
              />
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default EditCustomer;
